export const MODAL_MESSAGES = {
  confirmNextPage: {
    title: "Are you sure you want to move to the next page?",
    tabBar:"Are you sure want to move to other page",
    DataNotSavedtab:"Data not saved. Are you sure want to move to other page",
    DataNotSavedtitle:"Data are not saved. Are you sure want to move to next page"
  },
  errorSaveRequired: {
    title: "Save Required",
    content: "Please save your changes before proceeding.",
  },
};

export const RESET_MESSAGES = {
  title: "Are you sure you want to reset the goals?",
  content: "This action cannot be undone.",
  okText: "Reset",
  okType: "danger",
  cancelText: "Cancel",
};

export const SAVE_MESSAGES = {
  validAlert: "Fill the left over fields of active and duplicate question",
  title: `Are you sure you want to save/update the goal data?`,
  content: "Please confirm your action.",
  okText: "Save",
  cancelText: "Cancel",
};

export const VALIDATION_MESSAGE = {
  duplicateValidation:
    "Duplicate values detected for same goal. The changes will not be saved.",
    addQuestion:"Please fill in all fields before adding the same goal"
};
